module.exports = __webpack_public_path__ + "da0cfcef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/newspaper.svg
// module id = 1855
// module chunks = 15 16 17 32 33